import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import NewsDetail from "../pages/detail/news/page";
import ServiceDetail from "../pages/detail/service/page";
import EntertainmentDetail from "../pages/detail/entertainment/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryName",
    element: <CategoryPage />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/detail/service/:id",
    element: <ServiceDetail />,
  },
  {
    path: "/detail/entertainment/:id",
    element: <EntertainmentDetail />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;